<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    multiple
    placeholder="All"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in options"
      :key="item.key"
      :label="item.label"
      :value="item.key"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { ProxyType, ProxyTypeLabel, ProxyTypeLabels } from '@/api/types'

type ProxyTypeEntry = {
  key: ProxyType
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'ProxyTypeSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const options = ProxyTypeLabels.map<ProxyTypeEntry>(
      (proxyTypeLabel: ProxyTypeLabel) => {
        return {
          key: proxyTypeLabel.proxyType,
          label: proxyTypeLabel.label,
          disabled: false
        }
      }
    )

    const update = (newValue: Array<ProxyType>) => {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { options, update, value }
  }
})
</script>
